import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import Constantes from '../php/Constantes';
import Select from 'react-select';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

class ConsultarInscriptos extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            //-----------------------
            datosConsulta: [],
            consultaRealizada: false,
            todos: [],
            //-----------------------
            concursos: [],
            filteredConcursos: [],
            consulta: {
                concurso: '',
            },
            consultaEspecifica: false,
            datoEspecifico: {},
            departamentos: [],
            estadoEstudios: [],
            todosLosArchivos: [],
            archivosParticipante: [],

            listInscriptos: {
                todos: true,
                pendientes: false,
                aceptados: false,
                rechazados: false,
                condicional: false,
            },

            totalAceptados: '',
        }

        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
        this.manejarConsultarParticipante = this.manejarConsultarParticipante.bind(this);
        this.manejarVolverConsulta = this.manejarVolverConsulta.bind(this);
        this.manejarCambiosDatosEstado = this.manejarCambiosDatosEstado.bind(this);
        this.inscripcionListar = this.inscripcionListar.bind(this);
        this.manejarVolverConsultaEspecifica = this.manejarVolverConsultaEspecifica.bind(this);
        this.manejarEnviarInscripcion = this.manejarEnviarInscripcion.bind(this);
    }

    async componentDidMount(){
        const vac = await fetch(`${Constantes.RUTA_API}/obtener_concursos.php`);
        const datoCon = await vac.json();
        this.setState({
            errores: 'No existen datos',
        })
        if(datoCon[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                consursos: datoCon[1],
            });

            this.setState({ filteredConcursos: datoCon[1] });
        }

        const departamento = await fetch(`${Constantes.RUTA_API}/obtener_departamentosConcurso.php`);
        const datoDepartamento = await departamento.json();
        this.setState({
            departamentos: datoDepartamento,
        });

        const estadoEstudio = await fetch(`${Constantes.RUTA_API}/obtener_estadoEstudios.php`);
        const datoEstadoEstudio = await estadoEstudio.json();
        this.setState({
            estadoEstudios: datoEstadoEstudio,
        });
    }

    handleSelectChange = (selectedOption) => {
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
        })
        this.setState(state => {
            const consultaActualizado = state.consulta;

            consultaActualizado['concurso'] = selectedOption;
            return{
                consulta: consultaActualizado,
            };
        })
    };


    render(){
        const { filteredConcursos, searchInput } = this.state;
        const options = filteredConcursos.map(concurso => ({
            value: concurso.idLlamados,
            label: concurso.nombreLlamado
        }));
        return (
            <>
                {sessionStorage.login
                ?
                    null
                :
                    <Redirect to='/calmette-app/login'/>
                }
                <h3 style={{marginBottom: '1rem'}}>Consultar Inscriptos Concurso</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.consultaRealizada
                ?
                    null
                :
                    <Container>
                        <Table style={{marginLeft: '17rem'}} sx={{maxWidth: 500}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell style={{textAlign: 'center'}}>Concurso</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                    <StyledTableRow>
                                    <StyledTableCell style={{minWidth: '100%'}}><Select style={{width:"100%", border:"2px solid #D6EAF8"}} options={options} value={this.state.consulta.concurso} onChange={(selectedOption) => this.handleSelectChange(selectedOption)} /></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-primary mx-2" onClick={this.manejarEnvioConsulta}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                            </TableBody>
                        </Table>
                    </Container>
                }
                {this.state.consultaRealizada && (!this.state.consultaEspecifica)
                ?
                    <Container>
                        <FormControlLabel label='TODOS' control={<Checkbox checked={this.state.listInscriptos.todos} onChange={this.inscripcionListar} id='todos'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='PENDIENTES' control={<Checkbox checked={this.state.listInscriptos.pendientes} onChange={this.inscripcionListar} id='pendientes'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='ACEPTADOS' control={<Checkbox checked={this.state.listInscriptos.aceptados} onChange={this.inscripcionListar} id='aceptados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='RECHAZADOS' control={<Checkbox checked={this.state.listInscriptos.rechazados} onChange={this.inscripcionListar} id='rechazados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='CONDICIONAL' control={<Checkbox checked={this.state.listInscriptos.condicional} onChange={this.inscripcionListar} id='condicional'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <p style={{fontSize: '22px'}}>{this.state.consulta.concurso.label + ': ' + this.state.todos[0].totalTuplas + ' inscriptos, ' + this.state.totalAceptados + ' aceptados'}</p>
                    </Container>
                :
                    null
                }
                {this.state.consultaRealizada && (!this.state.consultaEspecifica)
                ?
                    <Container>
                        <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="Datos Inscriptos" sheet="pagina 1" buttonText="Exportar a Excel"></ReactHtmlTableToExcel>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto', marginTop: '1rem'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>C.I.</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Nombre</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Estado Inscripción</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.datosConsulta.map((name, index) => (
                                        <StyledTableRow key={index}>
                                            <StyledTableCell style={{textAlign: 'center'}}>{name.ci}</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}>{name.pNombre + ' ' + name.pApellido}</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}>{name.nombreEstadoInscripcion}</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-primary btn-sm mx-2" type='button' onClick={() => this.manejarConsultarParticipante(name)}>Consultar</button></StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        <button className="btn btn-outline-primary btn-sm mx-2" style={{marginTop:'0.5rem'}} type='button' onClick={this.manejarVolverConsulta}>Volver</button>
                    </Container>
                :
                    null
                }
                <Container>
                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta" style={{display: 'none'}}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell style={{textAlign: 'center'}}>Estado Inscripción</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>C.I.</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>P. Nombre</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>S. Nombre</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>P. Apellido</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>S. Apellido</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>Número Inscripción</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>Mail</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>Tipo Inscripción</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>Teléfono</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>Celular</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.todos.map((name, index) => (
                                    <StyledTableRow key={index}>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.nombreEstadoInscripcion}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.ci}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.pNombre}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.sNombre}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.pApellido}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.sApellido}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.numeroInscripcion}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.email}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.tipoInscripcion === 1 ? 'GENERAL' : name.tipoInscripcion === 2 ? 'PERSONAS TRANS' : name.tipoInscripcion === 3 ? 'AFRO-DESCENDIENTES' : name.tipoInscripcion === 4 ? 'PERSONAS VICTIMAS DE DELITOS VIOLENTOS' : ''}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.telefono}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.celular}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Container>
                {this.state.consultaEspecifica
                ?
                    <Container>
                        <br/>
                        <fieldset>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Llamado</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <h4>{this.state.consulta.concurso.label}</h4>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </fieldset>
                        <fieldset>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Tipo Inscripción</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8", textAlign: 'center'}} id='tipoInscripcion' value={this.state.datoEspecifico.tipoInscripcion} >
                                            <option value=''></option>
                                            <option key={1} value={1}>GENERAL</option>
                                            <option key={2} value={2}>PERSONAS TRANS</option>
                                            <option key={3} value={3}>AFRO-DESCENDIENTES</option>
                                            <option key={4} value={4}>PERSONAS VICTIMAS DE DELITOS VIOLENTOS</option>
                                        </select>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </fieldset>
                        <fieldset>
                            <legend>Datos Personales</legend>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Primer Nombre <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.pNombre}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Segundo Nombre</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.sNombre}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Primer Apellido <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.pApellido}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Segundo Apellido</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.sApellido}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>C.I. (SIN PUNTOS NI GUIONES) <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.ci}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Fecha Nacimiento <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input disabled={true} min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='fNacimiento' value={this.state.datoEspecifico.fNacimiento}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Credencial</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.credencialSerie + ' ' + this.state.datoEspecifico.credencialNumero}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {/*Estolo pongo para un salto de linea */}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Direccion <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={6}>
                                        {this.state.datoEspecifico.direccion}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Departamento <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='departamento' value={this.state.datoEspecifico.departamento}>
                                            <option value=''>DEPARTAMENTO</option>
                                            {this.state.departamentos.map((name) =>
                                                <option
                                                key={name.idDepartamentos}
                                                value={name.idDepartamentos}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Teléfono</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.telefono}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Celular <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.celular}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Carné De Salud</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input disabled={true} min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='carneSalud' value={this.state.datoEspecifico.carneSalud}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Sexo <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='sexo' value={this.state.datoEspecifico.sexo}>
                                            <option value={''}>SEXO</option>
                                            <option value={0}>MASCULINO</option>
                                            <option value={1}>FEMENINO</option>
                                            <option value={2}>OTRO</option>
                                        </select>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Mail <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.email}
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <fieldset style={{marginTop: '1rem'}}>
                            <legend>Estudios</legend>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Bachillerato <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='bachillerato' value={this.state.datoEspecifico.bachillerato} onChange={this.manejarCambiosDatos} >
                                            <option value=''></option>
                                            {this.state.estadoEstudios.map((name) =>
                                                <option
                                                key={name.idEstadoEstudio}
                                                value={name.idEstadoEstudio}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Universidad <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='universidad' value={this.state.datoEspecifico.universidad} >
                                            <option value=''></option>
                                            {this.state.estadoEstudios.map((name) =>
                                                <option
                                                key={name.idEstadoEstudio}
                                                value={name.idEstadoEstudio}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <fieldset>
                            <legend>Documentos</legend>
                            <TableContainer style={{width: '50%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                                <Table sx={{minWidth: 400}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Nombre Documento</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.archivosParticipante.map((pdf, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell>{pdf.name}</StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf(pdf.name, pdf.data)}>Descargar</button></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </fieldset>
                        <fieldset style={{marginTop: '1rem'}}>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={5}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select disabled={this.state.datoEspecifico.estadoInscripcion === 1}  style={{width:"100%", border:"2px solid #D6EAF8", textAlign: 'center'}} id='estadoInscripcion' value={this.state.datoEspecifico.estadoInscripcion} onChange={this.manejarCambiosDatosEstado}>
                                            <option value={0} key={0}>PENDIENTE</option>
                                            <option value={1} key={1}>ACEPTADO</option>
                                            <option value={2} key={2}>RECHAZADO</option>
                                            <option value={3} key={3}>CONDICIONAL</option>
                                        </select>
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        {(this.state.datoEspecifico.estadoInscripcion === 0) || (this.state.datoEspecifico.estadoInscripcion === 1) || (this.state.datoEspecifico.estadoInscripcion === '0') || (this.state.datoEspecifico.estadoInscripcion === '1')
                        ?
                            null
                        :
                            <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='motivoRechazoCondicional' value={this.state.datoEspecifico.motivoRechazoCondicional} onChange={this.manejarCambiosDatosEstado}/>
                        }
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.loading
                        ?
                            <div style={{placeItems: 'center'}}>
                                <Box sx={{alignItems: 'center'}}>
                                    <CircularProgress/>
                                </Box>
                            </div>
                        :
                            null
                        }
                        <button className="btn btn-outline-primary btn-sm mx-2" style={{marginTop:'0.5rem'}} type='button' onClick={this.manejarVolverConsultaEspecifica}>Volver</button>
                        <button disabled={this.state.datoEspecifico.estadoInscripcion === 1} className="btn btn-outline-primary btn-sm mx-2" style={{marginTop:'0.5rem'}} type='button' onClick={this.manejarEnviarInscripcion}>Enviar</button>
                        <br/>
                        <br/>
                    </Container>
                :
                    null
                }
            </>
        )
    }

    async manejarEnvioConsulta(){
        //e.preventDefault();
        if(this.state.consulta.concurso === ''){
            this.setState({
                errores: 'Debe indicar el concurso a consultar',
            })
        }else{
            this.setState({
                errores: null,
                //notificaciones: null,
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.consulta]);

            const infoSol = await fetch(`${Constantes.RUTA_API}/consultar_inscripcionesConcurso.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await infoSol.json();

            this.setState({
                errores: res[1],
                //notificaciones: null,
                loading: false
            })

            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    //notificaciones: null,
                    loading: false,
                    datosConsulta: res[1],
                    todos: res[1],
                    consultaRealizada: true,
                    todosLosArchivos: res[2],
                    totalAceptados: res[3],
                })
            }
        }
    }

    async manejarConsultarParticipante(dato){
        
        
        //-------------------------------------------
        this.setState({
            errores: null,
            //notificaciones: null,
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.consulta, dato]);

        const infoSol = await fetch(`${Constantes.RUTA_API}/consultar_inscriptoConcurso.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await infoSol.json();

        this.setState({
            errores: res[1],
            //notificaciones: null,
            loading: false
        })

        if(res[0] === 'ok'){
            this.setState({
                loading: false,
                datoEspecifico: dato,
                consultaEspecifica: true,
                errores: null,
                notificaciones: null,
                archivosParticipante: res[1],
            })
        }
        //-------------------------------------------

        /*this.setState(prevState => ({
            archivosParticipante: prevState.todosLosArchivos.filter(todosLosArchivos => todosLosArchivos.ci === dato.ci)
        }));*/
    }

    manejarVolverConsulta(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
            datosConsulta: [],
            consultaEspecifica: false,
            datoEspecifico: {},
            listInscriptos: {
                todos: true,
                pendientes: false,
                aceptados: false,
                rechazados: false,
                condicional: false,
            },
        })
    }

    manejarCambiosDatosEstado(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.datoEspecifico;
            movimientosActualizado[clave] = valor;
            return{
                datoEspecifico: movimientosActualizado,
            };
        })
    }

    inscripcionListar(e){
        const clave = e.target.id;
        this.setState({
            notificaciones: null,
            errores: null,
            loading: false,
        })
        if(clave === 'todos'){
            this.setState({
                listInscriptos: {
                    todos: true,
                    pendientes: false,
                    aceptados: false,
                    rechazados: false,
                    condicional: false,
                },
            });
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoInscripcion !== '')
            }));
        }else if(clave === 'pendientes'){
            this.setState({
                listInscriptos: {
                    todos: false,
                    pendientes: true,
                    aceptados: false,
                    rechazados: false,
                    condicional: false,
                },
            })
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoInscripcion === 0)
            }));
        }else if(clave === 'aceptados'){
            this.setState({
                listInscriptos: {
                    todos: false,
                    pendientes: false,
                    aceptados: true,
                    rechazados: false,
                    condicional: false,
                },
            })
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoInscripcion === 1)
            }));
        }else if(clave === 'rechazados'){
            this.setState({
                listInscriptos: {
                    todos: false,
                    pendientes: false,
                    aceptados: false,
                    rechazados: true,
                    condicional: false,
                },
            })
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoInscripcion === 2)
            }));
        }else if(clave === 'condicional'){
            this.setState({
                listInscriptos: {
                    todos: false,
                    pendientes: false,
                    aceptados: false,
                    rechazados: false,
                    condicional: true,
                },
            })
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoInscripcion === 3)
            }));
        }
    }

    manejarVolverConsultaEspecifica(e){
        e.preventDefault();
        this.setState({
            consultaEspecifica: false,
            errores: null,
            notificaciones: null,
            loading: false,
            datoEspecifico: {},
        })
    }

    async manejarEnviarInscripcion(e){
        e.preventDefault();
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.datoEspecifico, this.state.totalAceptados]);

        const control = await fetch(`${Constantes.RUTA_API}/actualizar_inscripcion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Datos ingresados correctamente',
                consultaEspecifica: false,
                datoEspecifico: {},
            })

            this.manejarEnvioConsulta();
        }
    }
}

export default ConsultarInscriptos